import { APP_INITIALIZER, NgModule } from '@angular/core';
import { UsersnapService } from './usersnap.service';

@NgModule({
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory:
        (usersnapService: UsersnapService): (() => void) =>
        () =>
          usersnapService.addScriptToDom(),
      deps: [UsersnapService],
      multi: true
    }
  ]
})
export class UsersnapModule {}
